import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import UrlHelper from "../../utilities/UrlHelper";
import { validateVirtualUserTicket, setEmail } from "../../actions/EmailAuthenticationActions";
import CompleteAccountSetup from "./CompleteAccountSetup";
import ticketType from "../../entities/TicketType";

export class ConfirmEmailPage extends Component {
    constructor (props) {
        super(props);
        this.state = {
            email: ""
        };
        this.completeVerification = this.completeVerification.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        const ticket = UrlHelper.getParameterByName("ticket");
        this.state.ticket = ticket;
        this.props.validateVirtualUserTicket(ticket);
    }

    completeVerification () {
        this.props.setEmail(this.state.ticket);
    }

    render () {
        const email = this.props.email;
        const redirectLocation = this.props.redirectLocation;
        if (redirectLocation) {
            window.location = redirectLocation;
        }
        const title = "Last Step!";
        const text = "Click the Complete Account Setup button below to finish verifying your account and get started.";

        return (
            <div id="confirmEmailPage">
                <CompleteAccountSetup title={title}
                    text={text}
                    onComplete={this.completeVerification}
                    email={email}
                    completeButtonTitle="Complete Account Setup"/>
            </div>
        );
    }
}

ConfirmEmailPage.propTypes = {
    validateVirtualUserTicket: PropTypes.func,
    email: PropTypes.string,
    redirectLocation: PropTypes.string,
    setEmail: PropTypes.func
};

const mapStateToProps = state => ({
    email:  state.emailLoginState.email,
    redirectLocation: state.emailLoginState.redirectLocation
});

const mapDispatchToProps = (dispatch) => {
    return ({
        validateVirtualUserTicket: (ticket) => dispatch(validateVirtualUserTicket(ticket, ticketType.virtualUser.setEmail.value)),
        setEmail: (ticket) => dispatch(setEmail(ticket))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPage);
